(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/result-settings.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/result-settings.js');
"use strict";

const {
  useCallback,
  useState
} = React;
const {
  ExpandableArea
} = svs.components.tipsen.expandableArea;
const {
  ReactIconButton,
  ReactIcon
} = svs.ui;
const {
  ResultSettingsSelectorContainer
} = svs.components.tipsen.routeResult;
const {
  SettingsButton
} = svs.components.tipsen.couponChoiceButton;
const ResultSettings = () => {
  const [isShowingSettings, setIsShowingSettings] = useState(false);
  const onActivateSettings = useCallback(() => {
    setIsShowingSettings(!isShowingSettings);
  }, [isShowingSettings]);
  const settingsBtnContainer = document.querySelector('.pg_result__settings_button_container');
  let arrowPosition;
  if (settingsBtnContainer) {
    const settingsBtnContainerWidth = settingsBtnContainer.getBoundingClientRect().width;
    if (isShowingSettings) {
      const settingsButton = document.querySelector('.coupon-toolbox-settings-button');
      if (settingsButton) {
        const settingsRect = settingsButton.getBoundingClientRect();
        arrowPosition = settingsBtnContainerWidth - settingsRect.width / 2;
      }
    }
  }
  return React.createElement("div", {
    className: "pg_result__coupon_choises"
  }, React.createElement("div", {
    className: "pg_result__settings_button_container"
  }, React.createElement(SettingsButton, {
    isShowingSettings: isShowingSettings,
    onClick: onActivateSettings
  })), React.createElement(ExpandableArea, {
    arrowPosition: arrowPosition,
    className: ['pg_coupon_settings_selector', 'pg_coupon_settings_selector--result'],
    "data-testid": "expandable-area",
    isOpen: isShowingSettings
  }, isShowingSettings && React.createElement("div", {
    className: "pg_coupon_settings_selector__container pg_coupon_settings_selector__container--result"
  }, React.createElement(ReactIconButton, {
    className: "pg_coupon_settings_selector__close_btn",
    onClick: onActivateSettings
  }, React.createElement(ReactIcon, {
    icon: "close",
    size: "300"
  })), React.createElement(ResultSettingsSelectorContainer, null))));
};
setGlobal('svs.components.tipsen.routeResult.ResultSettings', ResultSettings);

 })(window);